import { Component, Input, OnChanges } from '@angular/core';
import * as _ from 'lodash';

@Component({
    selector: 'reactions-list',
    template: require('./reactions-list.component.html')
  })
  export class ReactionsListComponent implements OnChanges {
    @Input() reactions: { [key: string]: string };
    reactionTotals: Reaction[] = [];
    hasReactions: boolean = false;
  
    constructor() {}
  
    ngOnChanges(): void {
      this.reactionTotals = this.calculateReactionTotals(this.reactions);
      this.hasReactions = !_.isEmpty(this.reactions);
    }
  
    calculateReactionTotals(reactions: { [key: string]: string }): Reaction[] {
      const reactionsList: Reaction[] = [
        { glyph: 'heart', count: 0, users: [] },
        { glyph: 'thumbs-up', count: 0, users: [] },
        { glyph: 'thumbs-down', count: 0, users: [] },
        { glyph: 'question-sign', count: 0, users: [] },
      ];
  
      for (const user in reactions) {
        const reaction = reactions[user];
        switch (reaction) {
          case 'heart':
            reactionsList[0].count++;
            reactionsList[0].users.push(user);
            break;
          case 'thumbs-up':
            reactionsList[1].count++;
            reactionsList[1].users.push(user);
            break;
          case 'thumbs-down':
            reactionsList[2].count++;
            reactionsList[2].users.push(user);
            break;
          case 'question-sign':
            reactionsList[3].count++;
            reactionsList[3].users.push(user);
            break;
          default:
            break;
        }
      }
  
      return reactionsList;
    }
  
    toolTip(reactions: Reaction): string {
      if (reactions.count === 1) {
        return reactions.users[0];
      }
  
      let ret = reactions.users.slice(0, 3).join(', ');
      if (reactions.users.length > 3) {
        ret += ` and ${reactions.users.length - 3} others`;
      }
      return ret;
    }
  }
  
  interface Reaction {
    glyph: string;
    count: number;
    users: string[];
  }
